module.exports = __webpack_public_path__ + "img/PDFIconSmall.93087c1f.png";